import React, { useEffect, useRef, useState, createRef } from 'react'
import {
  SLowcodeList,
  SIDRender,
  SDrawer,
  STableActions,
  SActionBtn
} from 'shj-components'
import config from './config';
import dayjs from 'dayjs'
import {fileConfirm} from "@/utils/file.ts";
import { findResponseForFmsListByPage, exportCouponForFmsToTask,
   getEnum,  getEnumGoodsFrontend, findResponseByCouponId} from '@/services/fmsServices'
import { AddOrEditForm } from './components'
import { Button, message } from 'antd'
export default function PaymentServiceManage() {
  const [openModal, setModal] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [loadingMap, setLoadingMap] = useState<Record<string, boolean>>({});
  const [editData, setEditData] = useState(null);
  const listRef = useRef<any>();
  const childRef = createRef<any>()
  // 表格加载
  const fetchList = (values: any) => {
    const { current, pageSize, ...rest } = values;
    return new Promise(async (resolve, reject) => {
      try {
        const { current, pageSize, query } = values
        query.couponStatusList = query.couponStatusList?.split(',') || []
        query.sourceOrderBizTagList = query.sourceOrderBizTagList?.split(',') || []
        query.targetOrderBizTagList = query.targetOrderBizTagList?.split(',') || []
        findResponseForFmsListByPage(current, pageSize, query).then((res)=>{
          resolve(res)
        })
      } catch (e) {
        reject({ success: false });
      }
    });
  };
  // 查看
  const onInfo = (record) => {
    setLoadingMap(prev => ({ ...prev, [record.couponId]: true }))
    findResponseByCouponId({ couponId: record.couponId }).then((res) => {
      if (res) {
        setEditData(res)
        setReadOnly(true)
        setModal(true)
      }
    }).finally(()=>{
      setLoadingMap(prev => ({ ...prev, [record.couponId]: false }))
    })
  }
  // 刷新
  const reloadFn = () => {
    const {
      current: { reload },
    } = listRef;
    reload();
  };
  // 导出
  const exportTemplate = () => {
    setExportLoading(true)
    const query = listRef.current?.getSearch()?.getFieldsValue() || {}
    exportCouponForFmsToTask(query).then((res)=>{
      fileConfirm()
      setExportLoading(false)
    }).catch(()=>{
      setExportLoading(false)
    })
  }
  const getStatusOptions = () => {
    return new Promise(async resolve => {
      //  抵扣券状态
      const couponStatusList: any = await getEnumGoodsFrontend('com.shj.saas.plus.frontend.enums.CouponStatus')
      // 需求标签
      const bizOpTypeList: any = await getEnumGoodsFrontend('com.shj.saas.plus.crm.enums.BizOpTypeEnum')
      resolve({
        couponStatusList,
        bizOpTypeList
      },)
    })
  }
  // 右侧表格配置
  const extension = {
    request: { fetchList, getStatusOptions },
    events: {},
    customRender: {
       renderOperate(_, record: Record<string, any>) {
        return (
          <STableActions>
            <SActionBtn onClick={()=>{onInfo(record)}} loading={loadingMap[record.couponId] || false}>查看金蝶转款记录</SActionBtn>
          </STableActions>
        )
      },
      // 导出
      exportRender() {
        return (
          <Button onClick={() => exportTemplate()} loading={exportLoading}>
            导出
          </Button>
        )
      },
    },
  }
  return (
    <div>
      <SLowcodeList config={config} ref={listRef} {...extension} 
        searchMode="group"
       />
       <SDrawer
        title={'金蝶转款查询'}
        width="60%"
        isHideResetBtn={false}
        footer={[]}
        open={openModal}
        onClose={() => setModal(false)}
        destroyOnClose
        styles={{ header: { padding: '8px 15px' } }}
      >
        <AddOrEditForm ref={childRef} editData={editData} readOnly={readOnly} />
      </SDrawer>
    </div>
  )
}
